<template>
  <div>
      <el-upload
          class="upload-demo"
          action=""
          :before-upload="beforeAvatarUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="onSuccess"
          :on-error="handleError"
          :limit="1"
          :file-list="fileList"
      >
          <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ZipUpload",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    initFiles: {
      type: Array,
      default: () => [],
    },
    tipText: {
      type: String,
      default: "",
    },
    fileType: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
      timer: null,
      extraData:{}
    };
  },
  beforeUnmount() {
    this.clearTimer();
  },
  computed: {
    ...mapGetters(["currentUserRoleDepart"]),
  },
  methods: {
    handlePreview(file) {
      console.log('Preview', file);
    },
    handleRemove(file, fileList) {
      console.log('Remove', file, fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeAvatarUpload(file) {
        let maxFileSize = 500 * 1024 * 1024;
        const type = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (this.fileType && this.fileType.indexOf(type) === -1) {
          this.$message.error(`上传文件的格式不正确，可以上传${this.fileType}`);
          return false;
        }

        if (maxFileSize < file.size) {
          this.$message.error('文件大小不能超过限制!');
          return false;
        }

        // 检查文件名是否包含空格或中文字符
        const hasSpace = /\s/.test(type);
        const hasChinese = /[\u4e00-\u9fa5]/.test(type);

        if (hasSpace || hasChinese) {
          this.$message.error("文件名不能包含空格或中文字符，请重新选择。");
          return false;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("departId", this.currentUserRoleDepart.departId);
        formData.append("hospId", this.currentUserRoleDepart.hospId);
        this.$emit('changeLoading',true)
        this.$store.dispatch('FleZipUploadFile', { formData, data: { departId: this.currentUserRoleDepart.departId, hospId: this.currentUserRoleDepart.hospId } }, progressEvent => {
          const { loaded, total } = progressEvent;
          const percent = (loaded / total) * 99;
          file.onProgress({ percent });
        }).then(() => {
          this.$emit('changeLoading',false)
          this.$emit('changevisible', false);
          this.$message.success('文件上传成功，请您在选择影像中查看');
        }).catch(() => {});

        // 不要返回 false 以避免触发文件的移除
        return true; // 或者不写 return，因为默认返回值是 true
      },
    onSuccess(response, file) {
      // 文件上传成功回调
      console.log("文件上传成功:", response);
    },
    handleError(err, file) {
      // 文件上传失败回调
      console.error("文件上传失败:", err);
    }
  },
};
</script>
